<template>
  <div class="input-group input-group-outline mb-3" :class="{ 'focused is-focused': focused, 'is-filled': inputValue, 'my-input-disabled':this.isBlocked === true }">
    <label class="form-label">{{ label }}</label>
    <div class="datepicker-wrapper" style="width:100%">
      <i class="bx bx-calendar date-input"></i>
      <vuejs-datepicker v-if="dateReady" v-model="inputValue" :language="language" :format="customFormatter"
        @focus="focused = true" @blur="focused = false" @input="sendValue" :monday-first="true"
        input-class="form-control" :id="id" />
      <button v-if="inputValue && inputValue != 'def'" class="btn btn-danger clear-button" @click="clearDate">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { pt } from 'vuejs-datepicker/dist/locale';

export default {
  components: {
    vuejsDatepicker: Datepicker,
  },
  props: {
    value: { type: [String, Date], required: false, default: null },
    label: { type: String, required: false, default: '' },
    placeholder: { type: String, required: false, default: 'Selecione uma data' },
    c_css: { type: String, required: false, default: '' },
    autocomplete: { type: String, required: false, default: '' },
    id: { type: String, required: false, default: "" },
    userAdmin: { type: [Number, String], required: false }
  },
  data() {
    return {
      focused: false,
      inputValue: null,
      language: pt,
      dateReady: false
    };
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = this.toDate(newVal);
    }
  },
  mounted() {
    this.initializeDatepicker();

  },
  methods: {
    initializeDatepicker() {
      this.inputValue = this.toDate(this.value);
      this.dateReady = true; // Set dateReady to true after initialization
    },
    toDate(value) {
      if (!value) return null;
      if (value instanceof Date) return value;
      const date = new Date(value);
      const isValid = !isNaN(date.getTime());
      return isValid ? date : null;
    },
    sendValue(newVal) {
      this.$emit('input', newVal ? newVal.toISOString() : null, this.id);
    },
    customFormatter(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    clearDate() {
      this.inputValue = null;
      this.$emit('input', null, this.id);
    }
  }
};
</script>

<style scoped>
.clear-button {
  position: absolute;
  float: left;
  right: 12px;
  top: 10px;
  padding: 0px;
  font-size: 14px;
  line-height: 14px;
  height: 20px;
  width: 20px;
  border-radius: 4px;
}
</style>
<style>
.date-input {
  position: absolute;
  float: left;
  left: 12px;
  top: 13px;
  z-index: 3;
  font-size: 16px;
  color: #CCC;
}

.datepicker-wrapper .form-control {
  padding-left: 40px;
}
</style>